module.exports = __webpack_public_path__ + "media/images/badges/rumble-badge-f0aba1797b6ac2861e334f7e00a078a5.svg";